import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { environment } from "../../environments/environment";
import { ApiService } from "../api.service";

@Injectable({
  providedIn: "root",
})
export class AdminService {
  // createAbbrivation(reqObj: { table_name: any; field_name: any; field_value: any; field_short_text: any; field_full_text: any; }) {
  //   throw new Error('Method not implemented.');
  // }

  profile: any = {};
  disputesData: any[] = [];
  trans: any;
  vendorProfileDetails: any
  ticket: any = {}
  ticketDetails: any = []
  // vendorProfileDetails: any;
  advertiseDetails: any = {}
  healthTips: any = {}
  videoDetails: any = {};

  private validateAdminSubject = new BehaviorSubject<any | null>({});
  validateAdminSubject$ = this.validateAdminSubject.asObservable();

  setvalidateAdminSubject(uuid: any | null) {
    this.validateAdminSubject.next(uuid);
  }

  constructor(private http: HttpClient, private api: ApiService) { }

  createJobPosting(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.createJobPosting, data);
  }
  updateJobPosting(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.updateJobPosting, data);
  }
  validateAdmin(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.validateAdmin, data);
  }

  updateJobPostingStatus(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.updateJobPostingStatus, data);
  }

  getAllAppliedJobs(data: any) {
    return this.api.GET_BR(environment.ADMIN_APIS.getAllAppliedJobs, data);
  }

  emailBusinessPartnerVerification(data: any) {
    let verify_key = data.verify_key;
    return this.api.GET_BR(environment.ADMIN_APIS.emailBusinessPartnerVerification + "?verify_key=" + verify_key, data);
  }

  getAllJobs(data: any) {
    return this.api.GET_BR(environment.ADMIN_APIS.getAllJobs, data);
  }

  appliedJobs(data: any) {
    let id = data.id
    return this.api.GET_BR(environment.ADMIN_APIS.appliedJobs + "?job_id=" + id, data);
  }

  getAllResumes(data: any) {

    return this.api.GET_BR(environment.ADMIN_APIS.getAllResumes, data);
  }

  // languages
  getAllLanguages(data: any) {

    return this.api.GET_BR(environment.ADMIN_APIS.getAllLanguages, data);
  }
  getUserLangauges(data: any) {

    return this.api.GET_BR(environment.ADMIN_APIS.getUserLangauges, data);
  }
  createLanguage(data: any) {

    return this.api.POST_BR(environment.ADMIN_APIS.createLanguage, data);
  }
  updateLanguage(data: any) {

    return this.api.POST_BR(environment.ADMIN_APIS.updateLanguage, data);
  }

  deleteLanguage(data: any) {

    return this.api.POST_BR(environment.ADMIN_APIS.deleteLanguage, data);
  }

  createVendor(data: any) {

    return this.api.POST_BR(environment.ADMIN_APIS.createVendor, data);
  }

  getVendor(data: any) {

    return this.api.GET_BR(environment.ADMIN_APIS.getVendor, data);
  }

  uploadCompanyLogo(data: any) {

    return this.api.POST_BR(environment.ADMIN_APIS.uploadCompanyLogo, data);
  }

  deleteVendor(data: any) {

    return this.api.POST_BR(environment.ADMIN_APIS.deleteVendor, data);
  }

  updateVendor(data: any) {

    return this.api.POST_BR(environment.ADMIN_APIS.updateVendor, data);
  }

  downloadResume(data: any) {
    let id = data.id
    return this.api.GET_BR(environment.ADMIN_APIS.downloadResume + "?uuid=" + id, data);
  }

  createQualification(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.createQualification, data);
  }

  getAllQualification(data: any) {
    return this.api.GET_BR(environment.ADMIN_APIS.getAllQualification, data);
  }

  updateQualification(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.updateQualification, data);
  }

  deleteQualification(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.deleteQualification, data);
  }

  createIndustry(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.createIndustry, data);
  }

  getAllIndustries(data: any) {
    return this.api.GET_BR(environment.ADMIN_APIS.getAllIndustries, data);
  }

  deleteIndustry(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.deleteIndustry, data);
  }

  updateIndustry(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.updateIndustry, data);
  }

  changePassword(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.changePassword, data);
  }

  getAllSupports(data: any) {
    return this.api.GET_BR(environment.ADMIN_APIS.getAllSupports, data);
  }

  getAllFeedbacks(data: any) {
    return this.api.GET_BR(environment.ADMIN_APIS.getAllFeedbacks, data);
  }

  getAdminDashboard(data: any) {
    let uuid = data.uuid
    return this.api.GET_BR(environment.ADMIN_APIS.getAdminDashboard + "?uuid=" + uuid, data);
  }

  // country
  createCountry(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.createCountry, data);
  }

  getCountries(data: any) {
    return this.api.GET_BR(environment.ADMIN_APIS.getCountries, data);
  }

  updateCountry(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.updateCountry, data);
  }

  deleteCountry(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.deleteCountry, data);
  }

  getStatesByCountryId(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.getStatesByCountryId, data);
  }

  // states
  getStates(data: any) {
    return this.api.GET_BR(environment.ADMIN_APIS.getStates, data);
  }

  createStateMaster(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.createStateMaster, data);
  }

  updateState(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.updateState, data);
  }

  deleteState(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.deleteState, data);
  }

  getCitiesByStateId(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.getCitiesByStateId, data);
  }

  /* getCitiesByStateCode(data: any) {
    return this.api.GET_BR(environment.ADMIN_APIS.getCitiesByStateCode, data);
  } */

  getCitiesByStateCode(data: any) {
    let state_code = data.state_code;
    return this.api.GET_BR(environment.ADMIN_APIS.getCitiesByStateCode + "?state_code=" + state_code, data);
  }

  // city
  getCities(data: any) {
    return this.api.GET_BR(environment.ADMIN_APIS.getCities, data);
  }

  createCityMaster(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.createCityMaster, data);
  }

  deleteCity(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.deleteCity, data);
  }

  updateCity(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.updateCity, data);
  }

  getAllReligions(data: any) {
    return this.api.GET_BR(environment.ADMIN_APIS.getAllReligions, data);
  }

  createReligion(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.createReligion, data);
  }

  deleteReligion(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.deleteReligion, data);
  }

  updateReligion(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.updateReligion, data);
  }

  getAllCastes(data: any) {
    return this.api.GET_BR(environment.ADMIN_APIS.getAllCastes, data);
  }

  createCaste(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.createCaste, data);
  }

  updateCaste(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.updateCaste, data);
  }

  deleteCaste(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.deleteCaste, data);
  }

  getAllDesignations(data: any) {
    return this.api.GET_BR(environment.ADMIN_APIS.getAllDesignations, data);
  }

  createDesignation(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.createDesignation, data);
  }


  updateDesignation(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.updateDesignation, data);
  }

  deleteDesignation(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.deleteDesignation, data);
  }

  getAllChurchDenominations(data: any) {
    return this.api.GET_BR(environment.ADMIN_APIS.getAllChurchDenominations, data);
  }

  createChurchDenomination(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.createChurchDenomination, data);
  }

  updateChurchDenomination(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.updateChurchDenomination, data);
  }

  deleteChurchDenomination(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.deleteChurchDenomination, data);
  }

  getAllVendors(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.getAllVendors, data);
  }

  getAllChurches(data: any) {
    return this.api.GET_BR(environment.ADMIN_APIS.getAllChurches, data);
  }
  getPlans(data: any) {
    return this.api.GET_BR(environment.ADMIN_APIS.getPlans, data);
  }
  paymentDisputes(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.paymentDisputes, data);
  }
  getDisputes(data: any) {
    return this.api.GET_BR(environment.ADMIN_APIS.getDisputes, data);
  }

  // employment
  getAllEmployeements(data: any) {
    return this.api.GET_BR(environment.ADMIN_APIS.getAllEmployeements, data);
  }
  createEmployeement(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.createEmployeement, data);
  }
  updateEmployeement(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.updateEmployeement, data);
  }
  deleteEmployeement(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.deleteEmployeement, data);
  }

  // job type
  getAllJobType(data: any) {
    return this.api.GET_BR(environment.ADMIN_APIS.getAllJobType, data);
  }

  // transactions
  getTransaction(data: any) {
    return this.api.GET_BR(environment.ADMIN_APIS.getTransaction, data);
  }


  // orders
  getOrders(data: any) {
    return this.api.GET_BR(environment.ADMIN_APIS.getOrders, data);
  }


  createJobType(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.createJobType, data);
  }
  deleteJobType(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.deleteJobType, data);
  }
  updateJobType(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.updateJobType, data);
  }


  // Business Sectors

  createBusinessType(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.createBusinessType, data);
  }

  updateBusinessType(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.updateBusinessType, data);
  }


  getAllBusinessType(data: any) {
    return this.api.GET_BR(environment.ADMIN_APIS.getAllBusinessType, data);
  }
  deleteBusinessType(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.deleteBusinessType, data);
  }

  getForbiddenWords(data: any) {
    let uuid = data.uuid
    return this.api.GET_BR(environment.ADMIN_APIS.getForbiddenWords + "?uuid=" + uuid, data);
  }

  createForbiddenWords(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.createForbiddenWords, data);
  }

  // FAQs
  createFaq(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.createFaq, data);
  }
  updateFaq(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.updateFaq, data);
  }
  deleteFaq(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.deleteFaq, data);
  }

  getAllFaqs(data: any) {
    let admin_uuid = data.admin_uuid
    return this.api.GET_BR(environment.ADMIN_APIS.getAllFaqs + "?admin_uuid=" + admin_uuid, data);
  }
  getNoofPDFFiles(data: any) {
    let admin_uuid = data.admin_uuid
    return this.api.GET_BR(environment.VENDOR_APIS.getNoofPDFFiles + "?admin_uuid=" + admin_uuid, data);
  }
  deleteInvoices(data: any) {
    let admin_uuid = data.admin_uuid
    return this.api.DELETE_BR(environment.VENDOR_APIS.deleteInvoices + "?admin_uuid=" + admin_uuid, data);
  }


  // hobbiess

  getHobbies(data: any) {
    return this.api.GET_BR(environment.ADMIN_APIS.getHobbies, data);
  }
  createHobby(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.createHobby, data);
  }
  updateHobby(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.updateHobby, data);
  }
  deleteHobby(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.deleteHobby, data);
  }


  // body type

  getAllBodyType(data: any) {
    return this.api.GET_BR(environment.ADMIN_APIS.getAllBodyType, data);
  }
  createBodyType(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.createBodyType, data);
  }
  updateBodyType(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.updateBodyType, data);
  }
  deleteBodyType(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.deleteBodyType, data);
  }

  // occupation
  getAllOccupation(data: any) {
    return this.api.GET_BR(environment.ADMIN_APIS.getAllOccupation, data);
  }
  userGetAllOccupation(data: any) {
    return this.api.GET_BR(environment.ADMIN_APIS.userGetAllOccupation, data);
  }
  createOccupation(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.createOccupation, data);
  }
  updateOccupation(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.updateOccupation, data);
  }
  deleteOccupation(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.deleteOccupation, data);
  }

  //matri-plans
  createMatiPlan(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.createMatiPlan, data);
  }
  getAllMatriPlans(data: any) {
    let admin_uuid = data.admin_uuid
    return this.api.GET_BR(environment.ADMIN_APIS.getAllMatriPlans + "?admin_uuid=" + admin_uuid, data);
  }

  deleteMatriPlan(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.deleteMatriPlan, data);
  }
  updateMatiPlan(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.updateMatiPlan, data);
  }

  //shop
  createCategory(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.createCategory, data);
  }
  getCategories(data: any) {
    return this.api.GET_BR(environment.ADMIN_APIS.getCategories, data);
  }
  deleteCategory(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.deleteCategory, data);
  }
  // getAllMatriPlans(data: any) {
  //   let admin_uuid=data.admin_uuid
  //   return this.api.GET_BR(environment.ADMIN_APIS.getAllMatriPlans+"?admin_uuid="+admin_uuid, data);
  // }
  // deleteMatriPlan(data: any) {
  //   return this.api.POST_BR(environment.ADMIN_APIS.deleteMatriPlan, data);
  // }
  // updateMatiPlan(data: any) {
  //   return this.api.POST_BR(environment.ADMIN_APIS.updateMatiPlan, data);
  // }

  // Varients
  getAllVariantType(data: any) {
    return this.api.GET_BR(environment.ADMIN_APIS.getAllVariantType, data);
  }
  createVariantType(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.createVariantType, data);
  }
  updateVariantType(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.updateVariantType, data);
  }
  deleteVariantType(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.deleteVariantType, data);
  }

  // Sub Varients
  getAllVariantSubType(data: any) {
    let id = data.id
    return this.api.GET_BR(environment.ADMIN_APIS.getAllVariantSubType + "?id" + id, data);
  }
  createVariantSubType(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.createVariantSubType, data);
  }
  updateVariantSubType(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.updateVariantSubType, data);
  }
  deleteVariantSubType(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.deleteVariantSubType, data);
  }
  updateCategory(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.updateCategory, data);
  }

  createJobPosition(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.createJobPosition, data);
  }
  updateJobPosition(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.updateJobPosition, data);
  }
  deleteJobPosition(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.deleteJobPosition, data);
  }
  getAllJobPositions(data: any) {
    return this.api.GET_BR(environment.ADMIN_APIS.getAllJobPositions, data);
  }
  getUserIndustries(data: any) {
    return this.api.GET_BR(environment.ADMIN_APIS.getUserIndustries, data);
  }
  getUserAgents(data: any) {
    let filter_qry = "?filter=" + data.filter + "&os_name=" + data.os_name + "&device=" + data.device + "&role=" + data.role
    return this.api.GET_BR(environment.ADMIN_APIS.getUserAgents + filter_qry, data);
  }
  adminRegistration(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.adminRegistration, data);
  }
  createTicketType(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.createTicketType, data);
  }
  getAllTicketType(data: any) {
    return this.api.GET_BR(environment.ADMIN_APIS.getAllTicketType, data);
  }
  updateTicketType(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.updateTicketType, data);
  }
  supportTicketReply(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.supportTicketReply, data);
  }

  getSupportTickets(data: any) {
    return this.api.GET_BR(environment.ADMIN_APIS.getSupportTickets, data);
  }

  agentforgotPassword(data: any): Observable<any> {
    return this.api.POST_BR(environment.ADMIN_APIS.agentforgotPassword, data);
  }
  agentChangePassword(data: any): Observable<any> {
    return this.api.POST_BR(environment.ADMIN_APIS.agentChangePassword, data);
  }
  updateAgentDetails(data: any): Observable<any> {
    return this.api.POST_BR(environment.ADMIN_APIS.updateAgentDetails, data);
  }
  validateAgent(data: any): Observable<any> {
    return this.api.POST_BR(environment.ADMIN_APIS.validateAgent, data);
  }
  getAgentDetails(data: any): Observable<any> {
    return this.api.GET_BR(environment.ADMIN_APIS.getAgentDetails, data);
  }

  getAgentReferalAmount(data: any): Observable<any> {
    let cadence = data.cadence;
    return this.api.GET_BR(environment.ADMIN_APIS.getAgentReferalAmount + "?cadence=" + cadence, data);
  }
  uploadAgentProfilePic(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.uploadAgentProfilePic, data);
  }
  createDocuments(data: any): Observable<any> {
    return this.api.POST_BR(environment.ADMIN_APIS.createDocuments, data);
  }

  getDocumentsById(data: any): Observable<any> {
    return this.api.GET_BR(environment.ADMIN_APIS.getDocumentsById, data);
  }
  deleteDocuments(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.deleteDocuments, data);
  }

  createHealthTip(data: any): Observable<any> {
    return this.api.POST_BR(environment.ADMIN_APIS.createHealthTip, data);
  }
  getAllHealthTips(data: any): Observable<any> {
    return this.api.GET_BR(environment.ADMIN_APIS.getAllHealthTips, data);
  }
  deleteHealthTip(data: any): Observable<any> {
    return this.api.POST_BR(environment.ADMIN_APIS.deleteHealthTip, data);
  }
  getLatestNewsAPI(data: any): Observable<any> {
    return this.api.GET_BR(environment.ADMIN_APIS.getLatestNewsAPI, data);
  }
  publishNews(data: any): Observable<any> {
    return this.api.POST_BR(environment.ADMIN_APIS.publishNews, data);
  }
  getPublisedNews(data: any): Observable<any> {
    return this.api.GET_BR(environment.ADMIN_APIS.getPublisedNews, data);
  }

  unPublishNews(data: any): Observable<any> {
    return this.api.POST_BR(environment.ADMIN_APIS.unPublishNews, data);
  }
  updateHealthTip(data: any): Observable<any> {
    return this.api.POST_BR(environment.ADMIN_APIS.updateHealthTip, data);
  }
  getAllAdmins(data: any): Observable<any> {
    return this.api.GET_BR(environment.ADMIN_APIS.getAllAdmins, data);
  }
  getAllAgents(data: any): Observable<any> {
    return this.api.GET_BR(environment.ADMIN_APIS.getAllAgents, data);
  }

  getActiveFaqs(data: any) {
    let application = data.application
    let module_name = data.module_name
    return this.api.GET_BR(environment.ADMIN_APIS.getActiveFaqs + "?application=" + application + "&module_name=" + module_name, data);
  }

  createVideo(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.createVideo, data);
  }
  getAllVideos(data: any) {
    return this.api.GET_BR(environment.ADMIN_APIS.getAllVideos, data);
  }
  updateVideo(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.updateVideo, data);
  }
  deleteVideo(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.deleteVideo, data);
  }
  //Admn Policy
  createPolicy(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.createPolicy, data);
  }
  getPolicy(data: any) {
    let admin_uuid = data.admin_uuid
    return this.api.GET_BR(environment.ADMIN_APIS.getPolicy + "?admin_uuid=" + admin_uuid, data);
  }
  updatePolicy(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.updatePolicy, data);
  }
  deletePolicy(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.deletePolicy, data);
  }
  updateVendorStatus(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.updateVendorStatus, data);
  }
  createAdminJobAdverts(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.createAdminJobAdverts, data);
  }
  deleteAdminJobAdverts(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.deleteAdminJobAdverts, data);
  }
  updateAdminJobAdverts(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.updateAdminJobAdverts, data);
  }
  getAllAdminJobAdverts(data: any) {
    return this.api.GET_BR(environment.ADMIN_APIS.getAllAdminJobAdverts, data);
  }
  uploadAdminAdvertsImage(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.uploadAdminAdvertsImage, data);
  }
  //Admn Blogs
  createBlog(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.createBlog, data);
  }
  getAllBlogs(data: any) {
    //let admin_uuid = data.admin_uuid
    return this.api.GET_BR(environment.ADMIN_APIS.getAllBlogs, data);
  }
  updateBlogById(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.updateBlogById, data);
  }
  deleteBlogById(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.deleteBlogById, data);
  }

  uploadBlogImage(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.uploadBlogImage, data);
  }

  getBlogBySlugName(data: any): Observable<any> {
    let slug = data.slug

    return this.api.GET_BR(environment.ADMIN_APIS.getBlogBySlugName + "?slug=" + slug, data);
  }

  createReportCategory(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.createReportCategory, data);
  }
  getAllReportCategories(data: any) {
    return this.api.GET_BR(environment.ADMIN_APIS.getAllReportCategories, data);
  }
  updateReportCategory(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.updateReportCategory, data);
  }
  deleteReportCategory(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.deleteReportCategory, data);
  }

  getStatesByCountryCode(data: any) {
    let country_code = data.country_code
    return this.api.GET_BR(environment.ADMIN_APIS.getStatesByCountryCode + "?country_code=" + country_code, data);
  }

  createPlanType(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.createPlanType, data);
  }
  updatePlanType(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.updatePlanType, data);
  }
  getPlansType(data: any) {
    return this.api.GET_BR(environment.ADMIN_APIS.getPlansType, data);
  }
  deletePlanType(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.deletePlanType, data);
  }

  createPlanComparison(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.createPlanComparison, data);
  }
  updatePlanComparison(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.updatePlanComparison, data);
  }
  getPlansComparison(data: any) {
    return this.api.GET_BR(environment.ADMIN_APIS.getPlansComparison, data);
  }

  deletePlanComparison(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.deletePlanComparison, data);
  }

  createBankDetails(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.createBankDetails, data);
  }
  createBusinessPartnerBankDetails(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.createBusinessPartnerBankDetails, data);
  }
  updateBankDetails(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.updateBankDetails, data);
  }
  getBankDetails(data: any) {
    return this.api.GET_BR(environment.ADMIN_APIS.getBankDetails, data);
  }
  getAllBusinessPartnerBankDetails(data: any) {
    return this.api.GET_BR(environment.ADMIN_APIS.getAllBusinessPartnerBankDetails, data);
  }
  updateBusinessPartnerBankDetails(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.updateBusinessPartnerBankDetails, data);
  }

  createAbbrivation(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.createAbbrivation, data);
  }
  getAbbrivations(data: any) {
    return this.api.GET_BR(environment.ADMIN_APIS.getAbbrivations, data);
  }
  updateAbbrivation(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.updateAbbrivation, data);
  }

  getDemo(data: any) {
    return this.api.GET_BR(environment.ADMIN_APIS.getDemo, data);
  }
  createPlanPriority(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.createPlanPriority, data);
  }
  updatePlanComparisonPriority(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.updatePlanComparisonPriority, data);
  }
  updateTransactionStatus(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.updateTransactionStatus, data);
  }
  getReferralBonusData(data: any) {
    let month = data.month
    let year = data.year
    return this.api.GET_BR(environment.ADMIN_APIS.getReferralBonusData + "?year=" + year + "?month=" + month, data);
  }

  updateVendorApplication(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.updateVendorApplication, data);
  }
  
  updateJobPlanFeatures(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.updateJobPlanFeatures, data);
  }


  getJobPlanFeatures(data: any) {
    let plan_id = data.plan_id
    return this.api.GET_BR(environment.ADMIN_APIS.getJobPlanFeatures + "?plan_id=" + plan_id, data);
  }
  
  updateMatriPlanFeatures(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.updateMatriPlanFeatures, data);
  }


  getMatriPlanFeatures(data: any) {
    let plan_id = data.plan_id
    return this.api.GET_BR(environment.ADMIN_APIS.getMatriPlanFeatures + "?plan_id=" + plan_id, data);
  }

  getPlanCompareFeaturesByModule(data: any) {
    let module_name = data.module_name
    return this.api.GET_BR(environment.ADMIN_APIS.getPlanCompareFeaturesByModule + "?module_name=" + module_name, data);
  }


getAllCountries(data: any) {
    return this.api.GET_BR(environment.ADMIN_APIS.getAllCountries, data);
  }
  getAdvertPlanFeatures(data: any) {
    let plan_id = data.plan_id
    return this.api.GET_BR(environment.ADMIN_APIS.getAdvertPlanFeatures + "?plan_id=" + plan_id, data);
  }
  getDbPlanFeatures(data: any) {
    let plan_id = data.plan_id
    return this.api.GET_BR(environment.ADMIN_APIS.getDbPlanFeatures + "?plan_id=" + plan_id, data);
  }

  updateAdvertPlanFeatures(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.updateAdvertPlanFeatures, data);
  }
  updateDbPlanFeatures(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.updateDbPlanFeatures, data);
  }

   getTransactionPlanFeatures(data: any) {
    let razorpay_payment_id = data.razorpay_payment_id
    let order_id = data.order_id
     return this.api.GET_BR(environment.ADMIN_APIS.getTransactionPlanFeatures + "?razorpay_payment_id=" + razorpay_payment_id + "&order_id=" + order_id, data);
  }

createCoupon(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.createCoupon, data);
  }

  getAllCoupons(data: any) {
    return this.api.GET_BR(environment.ADMIN_APIS.getAllCoupons, data);
  }

  updateCoupon(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.updateCoupon, data);
  }

  deleteCoupon(data: any) {

    return this.api.POST_BR(environment.ADMIN_APIS.deleteCoupon, data);
  }

  createVisaType(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.createVisaType, data);
  }

  getAllVisaType(data: any) {
    return this.api.GET_BR(environment.ADMIN_APIS.getAllVisaType, data);
  }

  updateVisaType(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.updateVisaType, data);
  }

  deleteVisaType(data: any) {

    return this.api.POST_BR(environment.ADMIN_APIS.deleteVisaType, data);
  }
  
  createWhatsapp(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.createWhatsapp, data);
  }

  getWhatsapp(data: any) {
    return this.api.GET_BR(environment.ADMIN_APIS.getWhatsapp, data);
  }

  updateWhatsapp(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.updateWhatsapp, data);
  }

  deleteWhatsapp(data: any) {

    return this.api.POST_BR(environment.ADMIN_APIS.deleteWhatsapp, data);
  }
  createResumeBuilderPlans(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.createResumeBuilderPlans, data);
  }

  getAllResumeBuilderPlans(data: any) {
    return this.api.GET_BR(environment.ADMIN_APIS.getAllResumeBuilderPlans, data);
  }

  updateResumeBuilderPlans(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.updateResumeBuilderPlans, data);
  }
  updateResumeBuilderPlanImage(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.updateResumeBuilderPlanImage, data);
  }

  deleteResumeBuilderPlans(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.deleteResumeBuilderPlans, data);
  }

  createResumeScore(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.createResumeScore, data);
  }

  getAllResumeScore(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.getAllResumeScore, data);
  }

  updateResumeScore(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.updateResumeScore, data);
  }

  deleteResumeScore(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.deleteResumeScore, data);
  }

  addCarrierAiAssistance(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.addCarrierAiAssistance, data);
  }
  
  getCarrierAiAssistance(data: any) {
    return this.api.GET_BR(environment.ADMIN_APIS.getCarrierAiAssistance, data);
  }

  getAllUsers(data: any) {
    return this.api.GET_BR(environment.ADMIN_APIS.getAllUsers, data);
  }

  updateVendorDocumentStatus(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.updateVendorDocumentStatus, data);
  }
  
  /* getPendingVendorDocuments(data: any) {
    return this.api.GET_BR(environment.ADMIN_APIS.getPendingVendorDocuments, data);
  } */
  getPendingVendorDocuments(data: any) {
    let vendor_id = data.vendor_id
    return this.api.GET_BR(environment.ADMIN_APIS.getPendingVendorDocuments + "?vendor_id=" + vendor_id, data);
  }
  getAllContacts(data: any) {
    return this.api.GET_BR(environment.ADMIN_APIS.getAllContacts, data);
  }
  adminReplyToContact(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.adminReplyToContact, data);
  }
  getAllNavigationLinks(data: any) {
    return this.api.GET_BR(environment.ADMIN_APIS.getAllNavigationLinks, data);
  }
  updateNavigationLink(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.updateNavigationLink, data);
  }
  createNavigationLink(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.createNavigationLink, data);
  }
  deleteNavigationLink(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.deleteNavigationLink, data);
  }

  createVendorRmDetails(data: any) {
    return this.api.POST_BR(environment.ADMIN_APIS.createVendorRmDetails, data);
  }
}
